<template>
    <hts-drawer
        v-model="visible"
        :submit="handleSubmitFormAddVehiclePlugin"
        :title="$t('labels.addVehiclePlugin')"
        :rules="rulesPluginRemooc"
        @close="closeOverSide"
        @undo="undo()">
        <hts-card>
            <template #title>
                <h3 class="title">
                    <span class="label">
                        {{ $t('labels.generalInformation') }}
                    </span>
                </h3>
            </template>
            <div
                class="grid gap-4"
                :class="columnClass">
                <hts-form-select
                    v-model="dataFormAddVehiclePlugin.type"
                    :label="$t('labels.vehicleModule.pluginType')"
                    required
                    :items="listPluginType"
                    key-id="key"
                    key-label="name"
                    :color="props.color"
                    name="type"
                    prop="type" />
                <hts-select-remooc
                    v-if="dataFormAddVehiclePlugin.type === PluginType.MOOC"
                    v-model="dataFormAddVehiclePlugin.pluginData"
                    v-model:name="dataFormAddVehiclePlugin.name"
                    :api="$urlPartner.vehicle.remooc.find"
                    :label="$t('labels.mooc')"
                    required
                    prop="pluginData" />
                <hts-form-input
                    v-else
                    v-model="dataFormAddVehiclePlugin.name"
                    :label="$t('labels.vehicleModule.pluginName')"
                    required
                    :color="props.color"
                    name="name"
                    prop="name" />
                <hts-form-input
                    v-model="dataFormAddVehiclePlugin.description"
                    :label="$t('labels.description')"
                    :color="props.color"
                    name="description"
                    prop="description" />
            </div>
        </hts-card>
    </hts-drawer>
</template>

<script setup lang="ts">
import { PluginType, ContainerTypes } from '../imports/form'

import SelectRemooc from '../autocomplete/select-remooc.vue'

const props = defineProps({
  color: {
    type: String,
    default: 'theme'
  },
  sizeSlideOver: {
    type: String,
    default: 'small'
  },
  sizeItemInput: {
    type: String,
    default: 'small'
  },
  column: {
    type: Number,
    default: 1
  },
  vehicleId: {
    type: String
  },
  vehicleIsSelected: {
    type: Object
  }
})

const _initForm = {
  pluginData: '',
  name: '',
  type: 'MOOC',
  status: '',
  description: ''
}
const emits = defineEmits(['close', 'refreshTables', 'reload'])
const dataFormAddVehiclePlugin = reactive({ ..._initForm })
const vehicleId = ref()
const visible = ref(false)
const creating = ref(false)
const openAddPlugin = (idVehicle: string) => {
  vehicleId.value = idVehicle
  visible.value = true
}
defineExpose({
  openAddPlugin
})
const closeOverSide = () => {
  visible.value = false
  undo()
}

const listPluginType = [
  {
    key: PluginType.MOOC,
    name: $t('labels.supplyList.mooc')
  }
  // {
  //   key: PluginType.OIL,
  //   name: $t('labels.supplyList.oil')
  // },
  // {
  //   key: PluginType.WHEEL,
  //   name: $t('labels.supplyList.wheel')
  // },
  // {
  //   key: PluginType.GENERATOR,
  //   name: $t('labels.supplyList.generator')
  // },
  // {
  //   key: PluginType.CONTAINER,
  //   name: $t('labels.supplyList.container')
  // },
  // {
  //   key: PluginType.CHARGE,
  //   name: $t('labels.supplyList.charge')
  // }
]

const listStatus = [
  {
    key: -1,
    value: $t('labels.vehicleModule.inactive')
  },
  {
    key: 1,
    value: $t('labels.vehicleModule.active')
  }
]

const handleSubmitFormAddVehiclePlugin = () => {
  const api = $urlPartner.vehicle.plugin.addPlugin
  creating.value = true
  $api(api, { body: { ...dataFormAddVehiclePlugin, vehicle: vehicleId.value } })
    .then((data: any) => {
      const resData: any = data.data.value
      if (resData.success) {
        Object.assign(dataFormAddVehiclePlugin, { ..._initForm })
        emits('refreshTables')
        process.client && $toast().success(resData.data)
        undo()
      }
      creating.value = false
      visible.value = false
    })
    .catch(() => {
      creating.value = false
    })
}

const undo = () => {
  Object.assign(dataFormAddVehiclePlugin, { ..._initForm })
}
const columnClass = computed(() => {
  if ($lodash.inRange(props.column, 1, 12)) {
    return `grid-cols-${props.column}`
  }

  return 'grid-cols-1'
})
const rulesPluginRemooc = computed(() => {
  const result: { [key: string]: any } = {}
  if (dataFormAddVehiclePlugin.type) {
    result.pluginData = 'required'
  }
  return result
})
</script>
